module.exports = __webpack_public_path__ + "img/icon-comment@3x.ef1b091e.png";